export default __webpack_public_path__ + "static/2-1c5e4c952ff243770ada7c1b16fb4ab8.jpeg";